import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Card,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Row,
  Col,
  Container
} from "reactstrap";
import Adriana from "./Equipe/Adriana.js";
import Aline from "./Equipe/Aline.js";
import AnaPaula from "./Equipe/AnaPaula.js";
import Dejoara from "./Equipe/Dejoara.js";
import Guilherme from "./Equipe/Guilherme.js";
import Icaro from "./Equipe/Icaro";
import Janira from "./Equipe/Janira.js";
import Jeverson from "./Equipe/Jeverson.js";
import Leonardo from "./Equipe/Leonardo.js";
import LuisEduardo from "./Equipe/LuisEduardo.js";
import Matheus from "./Equipe/Matheus";
import Mauricio from "./Equipe/Mauricio";
import Meiski from "./Equipe/Meiski";
import Naiara from "./Equipe/Naiara.js";
import Pedro from "./Equipe/Pedro";
import Rafaella from "./Equipe/Rafaella.js";
import Rebeca from "./Equipe/Rebeca";
import Robson from "./Equipe/Robson";
import Romeu from "./Equipe/Romeu";
import Tiago from "./Equipe/Tiago";

class TabsSection extends React.Component {
  state = {
    iconTabs: 1,
    plainTabs: 1
  };
  toggleNavs = (e, state, index) => {
    e.preventDefault();
    this.setState({
      [state]: index
    });
  };
  render() {
    return (
      <>
        <Row className="justify-content-center">
          <Col lg="10">
            <div className="nav-wrapper">
              <Nav
                className="nav-fill flex-column flex-md-row"
                id="tabs-icons-text"
                pills
                role="tablist"
              >
                <NavItem>
                  <NavLink
                    aria-selected={this.state.iconTabs === 1}
                    className={classnames("mb-sm-3 mb-md-0", {
                      active: this.state.iconTabs === 1
                    })}
                    onClick={e => this.toggleNavs(e, "iconTabs", 1)}
                    href="#sobre"
                    role="tab"
                  >
                    <i className="fa fa-institution mr-2" />
                    Sobre
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={this.state.iconTabs === 2}
                    className={classnames("mb-sm-3 mb-md-0", {
                      active: this.state.iconTabs === 2
                    })}
                    onClick={e => this.toggleNavs(e, "iconTabs", 2)}
                    href="#equipe"
                    role="tab"
                  >
                    <i className="fa fa-users mr-2" />
                    Equipe
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <Card className="shadow">
              <CardBody>
                <TabContent activeTab={"iconTabs" + this.state.iconTabs}>
                  <TabPane tabId="iconTabs1">
                    <img
                      alt="..."
                      className="img-fluid floating"
                      src={require("../../assets/img/enteromar.png")}
                    />
                    <hr/>
                    <Container>
                      <Row className="row-grid align-items-center">
                        <p className="description" style={{textAlign: "justify", textIndent: "20px"}}>
                          O grupo ENTEROMAR foi criado em 2011 e é  formado por pesquisadores  de diferentes áreas da Universidade Federal de Ciências da Saúde de Porto Alegre e da Universidade Federal do Rio Grande do Sul (UFRGS). Acreditamos que a interdisciplinaridade é uma grande aliada na construção de conhecimento — e, portanto, é preconizada na construção dos nossos projetos de pesquisa.
                        </p>
                        <p className="description" style={{textAlign: "justify", textIndent: "20px"}}>
                          Os projetos de pesquisa do grupo têm como um dos objetivos principais analisar a comunidade bacteriana presente em animais marinhos selvagens, tais como: pinguins, tartarugas, lobos-marinhos, golfinhos e baleias. Estudamos características fenotípicas e genotípicas dessas bactérias, principalmente as pertencentes ao gênero Enterococcus. O grupo de pesquisa também devolve ferramentas de bioinformática que auxiliam na caracterização genômica dessas bactérias, contribuindo para entender melhor as diferenças entre linhagens comensais e clínicas.
                        </p>
                      </Row>
                    </Container>
                    <hr/>
                  </TabPane>
                  <TabPane tabId="iconTabs2">
                        <Adriana/>
                        <Aline />
                        <AnaPaula/>
                        <Dejoara/>
                        <Guilherme/>
                        <Icaro/>
                        <Janira/>
                        <Jeverson/>
                        <Leonardo/>
                        <LuisEduardo/>
                        <Matheus/>
                        <Mauricio/>
                        <Meiski/>
                        <Naiara/>
                        <Pedro/>
                        <Rafaella />
                        <Rebeca/>
                        <Robson/>
                        <Romeu/>
                        <Tiago/>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default TabsSection;
